import { formatPrice } from "../../../../../../common/helpers/formatPrice";
import { extractCurrencyInfo } from "../../../../../../common/helpers/currency";
import type { RawCartCoupon } from "../../../../../../types";
import type { TransformedCartCoupon } from "../../../types/cartApiTypes";

/**
 * A pure helper function to transform an array of raw coupon objects.
 * Formats coupon discount values to be tax-inclusive.
 */
export const transformCoupons = (
  rawCoupons: RawCartCoupon[],
): TransformedCartCoupon[] => {
  if (!Array.isArray(rawCoupons)) {
    return [];
  }

  return rawCoupons.map((coupon) => {
    // Extract currency info from the coupon's totals object
    const currencyInfo = extractCurrencyInfo(coupon.totals);

    // --- MATHEMATICAL TAX-INCLUSIVE SUMS ---
    // Sum Net Discount + Discount Tax to output the complete tax-inclusive value
    const rawDiscountInt = parseInt(coupon.totals.total_discount || "0", 10);
    const rawDiscountTaxInt = parseInt(
      coupon.totals.total_discount_tax || "0",
      10,
    );
    const grossDiscountInt = rawDiscountInt + rawDiscountTaxInt;

    const discountAmountToShow = String(grossDiscountInt);

    // --- IDENTIFY VIRTUAL COUPONS ---
    // Virtual/Auto-applied coupons shouldn't be removable by the user
    const isRemovable = !["havale_indirimi", "ilk_siparis_promosyonu"].includes(
      coupon.code,
    );

    return {
      code: coupon.code,
      isRemovable,
      discountType: coupon.discount_type,
      totals: {
        totalDiscount: formatPrice(coupon.totals.total_discount, currencyInfo),
        totalDiscountTax: formatPrice(
          coupon.totals.total_discount_tax,
          currencyInfo,
        ),
        displayDiscount: formatPrice(discountAmountToShow, currencyInfo),
      },
    };
  });
};
